import { IconButton, Menu, Portal, useDisclosure } from '@chakra-ui/react';
import { t } from 'i18next';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { FiEdit, FiTrash } from 'react-icons/fi';

import type { ActionPublic, CompanyPublic, IndicatorPublic, UserPublic } from '@/client';
import EditAction from '@/components/actions/EditAction';

interface ActionsMenuProps {
  type: string;
  value: CompanyPublic | UserPublic | IndicatorPublic | ActionPublic;
  disabled?: boolean;
}

const ActionsMenu = ({ type, value, disabled }: ActionsMenuProps) => {
  const editModal = useDisclosure();
  const deleteModal = useDisclosure();

  return (
    <>
      <Menu.Root positioning={{ placement: 'bottom-start' }}>
        <Menu.Trigger asChild>
          <IconButton disabled={disabled} variant={'ghost'}>
            <BsThreeDotsVertical />
          </IconButton>
        </Menu.Trigger>
        <Portal>
          <Menu.Positioner>
            <Menu.Content>
              <Menu.Item value="edit" onClick={editModal.onOpen}>
                <FiEdit fontSize="16px" />
                {t('ui.edit')}
              </Menu.Item>
              <Menu.Item value="delete" onClick={deleteModal.onOpen} color="ui.danger">
                <FiTrash fontSize="16px" />
                {t('ui.delete')}
              </Menu.Item>
            </Menu.Content>
          </Menu.Positioner>
        </Portal>
        {type === 'Action' ? (
          <EditAction action={value as ActionPublic} isOpen={editModal.open} onClose={editModal.onClose} />
        ) : (
          <></>
        )}
      </Menu.Root>
    </>
  );
};

export default ActionsMenu;
